// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'Mac Claim',
    path: '/dashboard/mac_search_claim',
    icon: icon('ic_insurance'),
  },
  {
    title: 'EW Mac Submitted Claim',
    path: '/dashboard/ew_mac_submitted_claim',
    icon: icon('submit_claim'),
  }
];

export default navConfig;
